import { Pipe, PipeTransform } from '@angular/core'

@Pipe({
  name: 'protocolo',
})
export class ProtocoloPipe implements PipeTransform {
  transform(value: string, lenght: number): string {
    return value.toString().padStart(lenght, '0')
  }
}
